import MasonryWall from '@yeger/vue-masonry-wall'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(MasonryWall)
})
